<template>
    <div class="main main-padding tea-pro-deta">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span v-if="productKey=='1'">教师使用大屏详情</span>
                    <span v-if="productKey=='2'">教师使用移动授课助手详情</span>
                    <span v-if="productKey=='3'">教师使用备课助手详情</span>
                    <span v-if="productKey=='4'">教师使用智能PC详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持教师名称关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="column" :data="teacherList" @on-row-dblclick="goTeaUseDetails"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
            <!--<data-tab-->
                <!--:tabTitle="'教师使用大屏详情'"-->
                <!--:placeholder="'支持教师名称关键字搜索'"-->
                <!--:columns="column"-->
                <!--:data="teacherList"-->
                <!--:loading="loading"-->
                <!--:filters="filters"-->
            <!--&gt;</data-tab>-->
        </card>
    </div>
</template>
<script>
    import {findSceneDetailsList} from "../../../service/api.js";
    import dateSelect from "../../../components/dateSelect.vue";
    // import DataTab from "../../../components/DataTab.vue";
    export default {
        data () {
            return {
                schoolId: this.$route.query.schoolId, //学校ID
                schoolName: this.$route.query.schoolName, //学校名称
                selfStartDate: this.$route.query.parentalStartDate,//一级页面传来的开始时间
                selfEndDate: this.$route.query.parentalEndDate,//一级页面传来的结束时间
                parentalStartDate: this.$route.query.parentalStartDate,//记住页面传来的开始时间
                parentalEndDate: this.$route.query.parentalEndDate,//记住页面传来的结束时间
                curSeleMainStartDate: this.$route.query.curSeleMainStartDate,//三级页面传来的开始时间
                curSeleMainEndDate: this.$route.query.curSeleMainEndDate,//三级页面传来的结束时间
                type: this.$route.query.type,//三级页面传来的结束时间
                productKey: this.$route.query.productKey,
                loading:true,
                filters:{
                    total: 0,
                    pageCount: 0, // 页数
                    page: 1,
                    limit: 10
                },
                column: [
                    {
                        title: "姓名",
                        key: "fullName",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击进入教师使用大屏详情页面",
                                            //让超链接执行一个js函数，而不是跳转到一个地址
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.goTeaUseDetails(params.row, params.index);
                                            }
                                        }
                                    },
                                    params.row.fullName
                                )
                            ]);
                        }
                    },
                    {
                        title: "使用次数",
                        key: "count",
                        align: "center"
                    }
                ],
                teacherList: [],
                userId: "",
                keyWord: "",
                total: 0,
                pageCount: 0, // 页数
                page: 1,
                limit: 10
            };
        },
        components: {
            dateSelect, //时间选择组件
            // DataTab//表格
        },
        methods: {
            //翻页
            handleCurrentChange (val) {
                this.page = val;
                this.getSceneDetailsList();
            },
            //查询
            handleSearch () {
                this.total = 0;
                this.page = 1;
                this.getSceneDetailsList();
            },
            /**
             * 获取学校使用率列表
             */
            async getSceneDetailsList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startDate: _this.selfStartDate,
                    endDate: _this.selfEndDate,
                    userId: _this.userId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit,
                    proKey: _this.productKey
                };
                await findSceneDetailsList(params)
                    .then(function (data) {
                        _this.teacherList = data.rows;
                        _this.total = data.total_rows;
                        _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "boardMain",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        startDate: this.type==1?this.curSeleMainStartDate:this.parentalStartDate,
                        endDate: this.type==1?this.curSeleMainEndDate:this.parentalEndDate,
                    }
                });
            },

            // 点击教师名称进入教师使用大屏具体详情页面
            goTeaUseDetails (row, index) {
                this.$router.push({
                    name: "proUseDetails",
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        selfStartDate: this.selfStartDate,
                        selfEndDate: this.selfEndDate,
                        parentalStartDate: this.parentalStartDate,
                        parentalEndDate: this.parentalEndDate,
                        userId: row.userId,
                        proKey: this.productKey,
                        routerResource: 1,//路由来源
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.selfStartDate = startDate;
                this.selfEndDate = endDate;
                this.getSceneDetailsList();
            }
        },
        mounted () {
            this.getSceneDetailsList();
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.parentalStartDate, this.parentalEndDate);
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";
</style>
<style lang="scss">
    .tea-pro-deta {

        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-card-head {
             border-bottom: 0!important;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
